import React from "react";

/**
 * 확인/경고 모달 컴포넌트
 * @param {Object} props - 컴포넌트 속성
 * @param {boolean} props.isVisible - 모달 표시 여부
 * @param {string} props.title - 모달 제목
 * @param {string} props.message - 모달 메시지
 * @param {string} props.type - 모달 타입 ('confirm' | 'alert')
 * @param {Function} props.onConfirm - 확인 버튼 클릭 시 실행 함수
 * @param {Function} props.onCancel - 취소 버튼 클릭 시 실행 함수
 * @param {string} props.confirmText - 확인 버튼 텍스트
 * @param {string} props.cancelText - 취소 버튼 텍스트
 */
const PhotoFilterConfirmModal = ({
    isVisible,
    title = "확인",
    message,
    type = "confirm", // 'confirm' | 'alert'
    onConfirm,
    onCancel,
    confirmText = "예",
    cancelText = "아니오",
}) => {
    if (!isVisible) return null;

    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm();
        }
    };

    const handleCancel = () => {
        if (onCancel) {
            onCancel();
        }
    };

    return (
        <div className="modal-overlay active" id={`${type}-modal`}>
            <div className="modal-container">
                <div className="modal-header">
                    <h3 className="modal-title">{title}</h3>
                    <button className="modal-close" onClick={handleCancel}>
                        &times;
                    </button>
                </div>
                <div className="modal-body">
                    <p>{message}</p>
                </div>
                <div className="modal-footer">
                    {type === 'confirm' && (
                        <button 
                            className="modal-btn modal-btn-cancel"
                            onClick={handleCancel}
                        >
                            {cancelText}
                        </button>
                    )}
                    <button 
                        className={`modal-btn ${type === 'alert' ? 'modal-btn-primary' : 'modal-btn-primary'}`}
                        onClick={handleConfirm}
                    >
                        {type === 'alert' ? '확인' : confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PhotoFilterConfirmModal;
